// test2386
(2386 && 0);
